import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import i18n from 'i18n-js';

import TouchableElement from '@components/common/touchableElement';
import { font as initialFont } from '@styles/fonts';
import { scale as initialScale } from '@components/frame';
import Svg from '@styles/icons/svg';
import { getBoxShadowStyle } from '@styles/shadow';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

export default ({
  onPress,
  height = 42,
  text,
  color = 'Label/Light/Primary',
  C,
  borderBottom = false,
  shadow = true,
  borderRadiusTop = true,
  borderRadiusBottom = true,
  bg = 'Background / Light / Field',
  selected,
  scale = initialScale,
  font = initialFont,
}) => {
  const shadowStyles = getBoxShadowStyle({type: 'Field', C});

  return (
    <View
      style={[
        { height: scale(height), userSelect: 'none' },
        borderBottom && {
          borderBottomColor: C('Hairline/Light/No trans'),
          borderBottomWidth: StyleSheet.hairlineWidth,
        },
      ]}
    >
      <TouchableElement onPress={onPress} hitSlop={{ top: 0, bottom: 0, left: 0, right: 0 }}>
        {({ boxStyle, pressHoverColor }) => (
          <View
            style={[
              shadow && shadowStyles,
              {
                backgroundColor: C(pressHoverColor(bg)),
                height: '100%',
                width: '100%',
                justifyContent: 'space-between',
                alignContent: 'center',
                alignItems: 'center',
                flexDirection: 'row',
                paddingHorizontal: scale(15),
              },
              borderRadiusTop && {
                borderTopLeftRadius: scale(SCREEN_BORDER_RADIUS),
                borderTopRightRadius: scale(SCREEN_BORDER_RADIUS),
              },
              borderRadiusBottom && {
                borderBottomLeftRadius: scale(SCREEN_BORDER_RADIUS),
                borderBottomRightRadius: scale(SCREEN_BORDER_RADIUS),
              },
              boxStyle,
            ]}
          >
            <Text
              style={[
                {
                  color: C(pressHoverColor(color)),
                  textAlign: 'center',
                },
                font['Subhead 1'],
              ]}
            >
              {i18n.t(text)}
            </Text>
            <View style={{ opacity: selected ? 1 : 0 }}>
              <Svg icon="check" color="Selected/Light/Primary" width={scale(15)} height={scale(15)} />
            </View>
          </View>
        )}
      </TouchableElement>
    </View>
  );
};
